import { COOKIE_NAMES } from './constants';
import { readCookie, storeInCookie } from './cookies';
import { getBrowserFingerprint } from './fingerprint';
import { gatekeeper } from './gatekeeper';

export type PnpDevice = 'MOBILE' | 'DESKTOP';

export type PnpDeviceInfo = {
  device: PnpDevice;
  fingerprint: string;
  deviceId: string;
};

const MOBILE_UA_PATTERN = /android|iphone|ipad|ipod|iemobile|blackberry|opera mini/i;

export const detectDevice = (): PnpDevice => {
  if (gatekeeper?.isNative?.()) return 'MOBILE';

  return MOBILE_UA_PATTERN.test(navigator?.userAgent ?? '') ? 'MOBILE' : 'DESKTOP';
};

export const getOrCreateDeviceId = (device: PnpDevice): string => {
  const existingCookie = readCookie(COOKIE_NAMES.KAZUMO) ?? {};
  const deviceId: string =
    gatekeeper?.deviceInfo?.deviceId
    || existingCookie?.deviceInfo?.deviceId
    || crypto.randomUUID();

  const deviceInfo = {
    ...existingCookie?.deviceInfo,
    device,
    fingerprint: '',
    deviceId,
  };
  storeInCookie(COOKIE_NAMES.KAZUMO, 'deviceInfo', deviceInfo as unknown as string);

  return deviceId;
};

export const buildDeviceInfo = async (): Promise<PnpDeviceInfo> => {
  const device = detectDevice();
  const fingerprint = await getBrowserFingerprint();
  const deviceId = getOrCreateDeviceId(device);

  return { device, fingerprint, deviceId };
};
